import Admin from "../../components/auth/Admin";
import Layout from "../../components/layout/Layout";
import { TableBody, TableRow, TableCell, Typography } from "@material-ui/core";
import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Popup from "../../components/customHelpers/Popup";
import { IoMdAdd } from "react-icons/io";
import { Grid, Toolbar, InputAdornment, makeStyles } from "@material-ui/core";
import { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { FiEdit, FiEye } from "react-icons/fi";
import { MdOutlineDelete } from "react-icons/md";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineExport, AiOutlineImport } from "react-icons/ai";
import Controls from "../../components/controls/Controls";
import useTable from "../../components/customHelpers/useTable";
import Norecords from "../../components/customHelpers/Norecords";
import CompanyForm from "../../components/forms/CompanyForm";
import UpdateCompanyForm from "../../components/forms/UpdateCompanyForm";
import Notify from "../../components/customHelpers/Notify";
import Company from "../../actions/Company";
import Notification from "../../components/customHelpers/Notification";
import Loading from "../../components/customHelpers/Loading";
import ImportFile from "../../actions/ImportFile";
import { useHistory } from "react-router-dom";
import SaveFromFile from "../../components/SaveFromFile";
import CompanyDetails from "../../components/CompanyDetails";
const headCells = [
  { id: "logo", label: "Logo", disableSorting: true },
  { id: "name", label: "Name" },
  { id: "wereda", label: "wereda" },
  { id: "city", label: "City" },
  { id: "SubCity", label: "Sub City" },
  { id: "state", label: "State" },
  { id: "catagory", label: "Catagory" },
  { id: "actions", label: "Actions", disableSorting: true },
];
const makeData = (result) => {
  return result.map((data) => {
    return {
      name: data?.name,
      wereda: data.Address?.wereda || "",
      city: data.Address?.city || "",
      state: data.Address?.state || "",
      subCity: data.Address?.sub_city || "",
      state: data.Address?.state || "",
      kebele: data.Address?.kebele || "",
      street: data.Address?.street_no || "",
      logo: data?.logo,
      description: data.description || "",
      catagoryId: data.catagoryId || "",
      lat: data.Address?.location
        ? data.Address?.location.coordinates[0]
        : null,
      long: data.Address?.location
        ? data.Address?.location.coordinates[1]
        : null,
      Id: data.Id,
      createdAt: data.createdAt,
      catagory: data.Catagory?.name || "",
      web: data.web || "",
      email: data.email || "",
      pobox: data.Address?.pobox || "",
      news: data.News,
      PhoneNumbers: data.PhoneNumbers,
      OfficeNumbers: data.OfficeNumbers,
      Faxes: data.Faxes,
      SocialMedia: data.SocialMedia,
    };
  });
};
const useStyles = makeStyles((theme) => ({
  logo: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));

const Companies = () => {
  const classes = useStyles();
  const history = useHistory();
  const { viewAllCompanies, viewAllCompaniesWithPage, adminSearchCompany, deleteCompany } = Company();
  const { NotifyMessage, notify, setNotify } = Notify();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupBulkSave, setOpenPopupBulkSave] = useState(false);
  const [record, setRecord] = useState({
    data: [],
    colDefs: [],
  });
  const [openPopupUpdate, setOpenPopupUpdate] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const filePicker = useRef(null);
  const { data, colDefs, importExcel, setData } = ImportFile();
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [values, setValues] = useState({
    loading: false,
    companies: [],
    reload: false,
    totalCount: 0,
    phoneFilter: false,
  });
  const { loading, companies, reload, totalCount, phoneFilter } = values;

  const filterFn = useMemo(() => ({ fn: (items) => items }), []);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
    page,
    rowsPerPage,
    setPage,
  } = useTable(companies, headCells, filterFn, totalCount);

  useEffect(() => {
    if (isSearching) return;
    getAllCompanies(page, rowsPerPage);
  }, [reload, page, rowsPerPage, isSearching]);

  const getAllCompanies = (currentPage = 0, currentLimit = rowsPerPage || 10) => {
    setValues((prev) => ({
      ...prev,
      loading: true,
    }));
    viewAllCompaniesWithPage(currentPage, currentLimit, phoneFilter).then(
      (data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
          setValues((prev) => ({
            ...prev,
            loading: false,
          }));
        } else if (data.result) {
          setValues((prev) => ({
            ...prev,
            companies: makeData(data.result),
            totalCount: data.count,
            loading: false,
          }));
        } else {
          NotifyMessage({
            message: "Network time out,try again.",
            type: "error",
          });
          setValues((prev) => ({
            ...prev,
            loading: false,
          }));
        }
      }
    );
  };

  const openInPopup = (item) => {
    setRecordForEdit({ ...item, editing: true });
    setOpenPopupUpdate(true);
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteCompany(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
      }
    });
  };
  const debounceTimer = useRef(null);

  const handleSearch = useCallback(
    (event) => {
      const value = event.target.value;
      setSearchQuery(value);
      const trimmedQuery = value.trim();

      // Clear any pending debounce timer
      if (debounceTimer.current) clearTimeout(debounceTimer.current);

      if (!trimmedQuery) {
        // Query cleared — go back to paginated list
        setIsSearching(false);
        setPage(0);
        return;
      }

      // Debounce: wait 400ms after last keystroke before firing the request
      debounceTimer.current = setTimeout(() => {
        setIsSearching(true);
        setPage(0);
        setValues((prev) => ({ ...prev, loading: true }));

        adminSearchCompany(encodeURIComponent(trimmedQuery))
          .then((data) => {
            if (data.err) {
              NotifyMessage({ message: data.err, type: "error" });
              setValues((prev) => ({ ...prev, loading: false }));
              return;
            }
            const results = data.result || [];
            setValues((prev) => ({
              ...prev,
              companies: makeData(results),
              totalCount: results.length,
              loading: false,
            }));
          })
          .catch((err) => {
            NotifyMessage({ message: err.message || "Search failed", type: "error" });
            setValues((prev) => ({ ...prev, loading: false }));
          });
      }, 400);
    },
    [adminSearchCompany]
  );
  if (data && data.length != 0) {
    setRecord({ data, colDefs });

    setData([]);
    setOpenPopupBulkSave(true);
  }

  const handleExport = async () => {
    try {
      const response = await viewAllCompanies();
      if (response.err) {
        NotifyMessage({ message: response.err, type: "error" });
        return;
      }

      const allCompanies = makeData(response.result);
      if (!allCompanies.length) {
        NotifyMessage({ message: "No data to export", type: "error" });
        return;
      }

      const headers = [
        "Name",
        "Wereda",
        "City",
        "Sub City",
        "State",
        "Category",
        "Web",
        "Email",
        "Kebele",
        "Street",
      ];
      const rows = allCompanies.map((company) => [
        `"${company.name || ""}"`,
        `"${company.wereda || ""}"`,
        `"${company.city || ""}"`,
        `"${company.subCity || ""}"`,
        `"${company.state || ""}"`,
        `"${company.catagory || ""}"`,
        `"${company.web || ""}"`,
        `"${company.email || ""}"`,
        `"${company.kebele || ""}"`,
        `"${company.street || ""}"`,
      ]);

      const csvContent = [headers.join(","), ...rows.map((row) => row.join(","))].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "companies_export.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      NotifyMessage({ message: "Companies exported successfully", type: "success" });
    } catch (err) {
      NotifyMessage({ message: err.message || "Export failed", type: "error" });
    }
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Companies
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search Companies"
              className="searchInput"
              value={searchQuery}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />

            <Controls.Button
              text="Add New"
              variant="outlined"
              startIcon={<IoMdAdd />}
              className="newButton"
              onClick={() => {
                setOpenPopup(true);
                setRecordForEdit(null);
              }}
            />
            <Controls.Button
              text="Export"
              variant="outlined"
              startIcon={<AiOutlineExport />}
              className="newButton"
              onClick={handleExport}
            />
          </Toolbar>
          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <>
                  {" "}
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.Id}>
                            <TableCell>
                              {item.logo && (
                                <img
                                  className={classes.logo}
                                  src={item.logo}
                                  alt={item.logo}
                                />
                              )}
                            </TableCell>
                            <TableCell
                              style={{ color: "rgb(244,151,3)" }}
                              onClick={() => {
                                history.push({
                                  pathname: `/admin/company/${item.Id}`,
                                  state: item,
                                });
                              }}
                            >
                              {item.name}
                            </TableCell>
                            <TableCell>{item.wereda}</TableCell>
                            <TableCell>{item.city}</TableCell>
                            <TableCell>{item.subCity}</TableCell>
                            <TableCell>{item.state}</TableCell>
                            <TableCell>{item.catagory}</TableCell>

                            <TableCell>
                              <Controls.ActionButton
                                color="primary"
                                title="View"
                                onClick={() => {
                                  setRecordForEdit(item);
                                  setIsViewMode(true);
                                  setOpenPopupUpdate(true);
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="secondary"
                                title="Delete"
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title:
                                      "Are you sure to delete this company record?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => {
                                      onDelete(item.Id);
                                    },
                                  });
                                }}
                              >
                                <MdOutlineDelete fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={7} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </>
              )}
            </Grid>
          </Grid>

          <Popup
            title="Add Company"
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <CompanyForm
              NotifyMessage={NotifyMessage}
              getAllCompanies={getAllCompanies}
              setOpenPopup={setOpenPopup}
            />
          </Popup>
          <Popup
            title={isViewMode ? "Company Details" : "Update Company"}
            openPopup={openPopupUpdate}
            setOpenPopup={setOpenPopupUpdate}
          >
            {isViewMode ? (
              <CompanyDetails
                record={recordForEdit}
              />
            ) : (
              <UpdateCompanyForm
                recordForEdit={recordForEdit}
                NotifyMessage={NotifyMessage}
                getAllCompanies={getAllCompanies}
                setOpenPopup={setOpenPopupUpdate}
              />
            )}
          </Popup>
          <Popup
            title="Import Company"
            openPopup={openPopupBulkSave}
            setOpenPopup={setOpenPopupBulkSave}
            maxWidth={false}
          >
            <SaveFromFile
              file={record}
              NotifyMessage={NotifyMessage}
              setOpenPopupBulkSave={setOpenPopupBulkSave}
              getAllCompanies={getAllCompanies}
            />
          </Popup>
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
      </Admin>
    </Layout>
  );
};
export default Companies;
